import {
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { MatDrawer } from '@angular/material/sidenav';
import { ResizeEvent } from 'angular-resizable-element';
import { isEmpty } from 'lodash';
import { LngLatLike } from 'mapbox-gl';
import { AcukwikAirport } from 'src/app/models/AcukwikAirport';
import { SwimFilter } from 'src/app/models/filter';
import { SharedService } from 'src/app/layouts/shared-service';
import {
    Aircraftwatch,
    FlightWatchModelResponse,
} from '../../models/flight-watch';
import { FlightWatchMapService } from './services/flight-watch-map.service';
import { FlightWatchMapWrapperComponent } from './flight-watch-map-wrapper/flight-watch-map-wrapper.component';
import { FlightWatchAicraftGridComponent } from './flight-watch-aicraft-grid/flight-watch-aicraft-grid.component';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import * as SharedEvents from 'src/app/constants/sharedEvents';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { MapQueryParams, MapType } from 'src/app/enums/map.enum';
import { TwelveHundredAeroMapComponent } from './flight-watch-map/twelve-hundred-aero-map/twelve-hundred-aero-map.component';
import { FlightWatchMapSharedService } from './services/flight-watch-map-shared.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FlightWatchFilterService } from './services/flight-watch-filter.service';
import { FlightWatchIcaoService } from './services/flight-watch-icao.service';
import { FlightWatchUserContextService } from './services/flight-watch-user-context.service';
import { ResizeStyle } from './models/flight-watch-resize-style.interface';
import { FLIGHT_WATCH_CONSTANTS } from './config/flight-watch.config';
import { MapAllowedIcaosService } from 'src/app/services/map-allowed-icaos.service';
import { MapAllowedIcao } from 'src/app/models/map-allowed-icao';
import { localStorageAccessConstant } from 'src/app/constants/LocalStorageAccessConstant';
@Component({
    selector: 'app-flight-watch',
    styleUrls: ['./flight-watch.component.scss'],
    templateUrl: './flight-watch.component.html',
})
export class FlightWatchComponent implements OnInit, OnDestroy {
    @Input() showBreadcrumb: boolean = true;
    @Input() showFilters: boolean = true;
    @Input() showLegend: boolean = true;
    @Input() isLobbyView: boolean = false;

    @ViewChild(FlightWatchMapWrapperComponent)
    private mapWrapper: FlightWatchMapWrapperComponent;
    @ViewChild('mapfilters') public drawer: MatDrawer;
    @ViewChild('flightwatchAircraftGrid') public flightwatchAircraftGrid: FlightWatchAicraftGridComponent;
    @ViewChild('twelveHundredAeroMap') public twelveHundredAeroMap: TwelveHundredAeroMapComponent;

    pageTitle = 'Flight Watch';
    chartName = 'FlightWatchLoader';

    isStable = true;
    center: LngLatLike = null;

    flightWatchData: FlightWatchModelResponse[] = null;
    filteredFlightWatchData: FlightWatchModelResponse[];
    acukwikairport: AcukwikAirport[];
    airportsICAO: string[];
    selectedICAO: string;
    groupId: number = null;

    style: ResizeStyle = {};
    currentFilters: SwimFilter = {
        filterText: '',
        dataType: null,
        isCommercialAircraftVisible: true,
        filteredTypes: [],
    };

    valueChangedSubscription: Subscription;
    lodingspinnerSubscription: Subscription;
    isDefaultMap: boolean = true;
    fboId: number = null;
    fboName: string = null;
    isMapToogleButtonVisible: boolean = false;
    allowedIcaos: MapAllowedIcao[] = [];
    
    constructor(
        private flightWatchMapService: FlightWatchMapService,
        private flightWatchMapSharedService: FlightWatchMapSharedService,
        private flightWatchFilterService: FlightWatchFilterService,
        private flightWatchIcaoService: FlightWatchIcaoService,
        private flightWatchUserContextService: FlightWatchUserContextService,
        private sharedService: SharedService,
        private cdref: ChangeDetectorRef,
        private route: ActivatedRoute,
        private ngxLoader: NgxUiLoaderService,
        private mapAllowedIcaosService: MapAllowedIcaosService,
        ) {
        
        const userContext = this.flightWatchUserContextService.getUserContext();
        this.selectedICAO = userContext.selectedICAO;
        this.fboId = userContext.fboId;
        this.fboName = userContext.fboName;
        this.groupId = userContext.groupId;
        
        this.lodingspinnerSubscription = this.flightWatchMapSharedService.lodingspinner$.subscribe( (data: boolean) => {
            if(data)
                this.ngxLoader.startLoader(this.chartName);
            else
                this.ngxLoader.stopLoader(this.chartName);
        });
    }
    ngAfterContentChecked() {
        this.cdref.detectChanges();

    }
    ngAfterViewInit() {
        if(this.isDefaultMap)
            this.toggleSettingsDrawer();
        
        this.isMapToogleButtonVisible = this.getMapToogleButtonState();
    }
    async ngOnInit() {
        const queryParams = this.route.snapshot.queryParams;
        const maptype = queryParams[MapQueryParams.MapType];
        const icao = queryParams[MapQueryParams.icao]?.toUpperCase();
        this.isDefaultMap = maptype == MapType.Aero ? false : true;
        if(icao && maptype == MapType.Aero){
            this.selectedICAO = icao;
            this.sharedService.setCurrentUserPropertyValue(
                localStorageAccessConstant.icao,
                icao
            );
        }

        if(this.center == null)
            this.center = await this.flightWatchMapService.getMapCenter(this.selectedICAO);

        this.loadAllowedIcaos();

        this.valueChangedSubscription = this.sharedService.valueChanged$.subscribe((value: {event: string, data: any}) => {
            if(value.event === SharedEvents.flightWatchDataEvent){
                if(value.data){
                    this.flightWatchData = this.flightWatchMapService.filterArrivalsAndDepartures(value.data);
                    this.isStable = true;
                }else{
                    this.flightWatchData = [];
                    this.isStable = false;
                }
                this.applyFiltersToData();
            }
            if (value.event == SharedEvents.flyToOnMapEvent) {
                this.center = this.flightWatchMapService.getMapCenterByCoordinates(value.data.latitude,value.data.longitude);
            }
        });
    }
    ngOnDestroy() {
        this.valueChangedSubscription?.unsubscribe();
        this.lodingspinnerSubscription?.unsubscribe();
        try {
            this.ngxLoader.stopLoader(this.chartName);
        } catch {}
    }
    getMapToogleButtonState(): boolean {
        if (!this.allowedIcaos || this.allowedIcaos.length === 0) {
            return false;
        }
        return this.allowedIcaos.some(x => 
            x.icao.toUpperCase().trim() === this.selectedICAO.toUpperCase().trim()
        );
    }

    private loadAllowedIcaos(): void {
        this.mapAllowedIcaosService.getAll().subscribe({
            next: (data: MapAllowedIcao[]) => {
                this.allowedIcaos = data;
                this.isMapToogleButtonVisible = this.getMapToogleButtonState();
            },
            error: (error) => {
                console.error('Error loading allowed ICAOs:', error);
                this.allowedIcaos = [];
            }
        });
    }
    setIcaoList(airportList: AcukwikAirport[]) {
        this.acukwikairport = airportList;
        this.airportsICAO = this.flightWatchIcaoService.setIcaoList(airportList);
    }
    updateIcao(icao: string) {
        this.flightWatchIcaoService.updateIcao(icao, this.mapWrapper, this.sharedService);
        this.selectedICAO = icao;
        this.sharedService.setCurrentUserPropertyValue(localStorageAccessConstant.icao, this.selectedICAO);
        this.isMapToogleButtonVisible = this.getMapToogleButtonState();
        this.sharedService.emitChange(SharedEvents.icaoChangedEvent);
    }
    onTextFilterChanged(filter: string): void {
        this.currentFilters.filterText = filter;
        this.applyFiltersToData();
    }
    applyFiltersToData(): void {
        this.filteredFlightWatchData = this.flightWatchFilterService.filterData(
            this.currentFilters,
            this.flightWatchData
        );
    }
    validate(event: ResizeEvent): boolean {
        const { MAX_DIMENSIONS_PX, MIN_DIMENSIONS_PX } = FLIGHT_WATCH_CONSTANTS;
        if (
            event.rectangle.width &&
            (event.rectangle.width > MAX_DIMENSIONS_PX ||
                event.rectangle.width < MIN_DIMENSIONS_PX)
        ) {
            return false;
        }
        return true;
    }

    onResizeEnd(event: ResizeEvent): void {
        this.style = {
            width: `${event.rectangle.width}px`,
        };

        setTimeout(() => {
            this.mapWrapper.map.mapResize();
        });
    }

    get mapWidth() {
        if (isEmpty(this.style)) {
            return FLIGHT_WATCH_CONSTANTS.DEFAULT_MAP_WIDTH;
        }
        return `calc(100% - ${this.style.width})`;
    }

    onTypesFilterChanged(filteredTypes: string[]) {
        this.currentFilters.filteredTypes = filteredTypes;
        this.applyFiltersToData();
    }
    async updateButtonOnDrawerResize() {
        if (!this.drawer.opened) return;
        await this.drawer.toggle();
        this.toggleSettingsDrawer();
    }
    async toggleSettingsDrawer() {
        await this.drawer.toggle();
        if(!this.isDefaultMap) return;
        this.mapWrapper.resizeMap(this.drawer.opened);
    }
    get isDrawerOpen() {
        return this.drawer?.opened ?? true;
    }
    filterCommercialAircrafts(isCommercialAircraftVisible: boolean) {
        this.currentFilters.isCommercialAircraftVisible =
            isCommercialAircraftVisible;
        this.applyFiltersToData();
    }
    async onAircraftClick(flightWatch: FlightWatchModelResponse) {
        if(!this.drawer.opened){
            await this.toggleSettingsDrawer();
        }
        this.flightwatchAircraftGrid.expandRow(flightWatch.tailNumber);
    }
    onPopUpClosed(flightWatch: FlightWatchModelResponse) {
        this.flightwatchAircraftGrid.collapseAllRows();
    }
    updatePopUp(event: Aircraftwatch){
        this.mapWrapper.map.updateAircraft(event);
    }
}
